export *  from './RouteHome';
export * from './RoutePrivate';
export *  from './RoutePublic';
export * from './RouteVariant';



// WEBPACK FOOTER //
// ./scripts/routers/index.js